module.exports = __webpack_public_path__ + "static/media/logo.81e884aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 617
// module chunks = 0